export default [
    { edIndustry: "ABRASIVES AND GRINDING" },
    {
        edIndustry: "ACCOUNTINGAUDITING TAX ACTIVITIES",
    },
    {
        edIndustry: "ADVERTISING AND PUBLICITY CONCERNS",
    },
    { edIndustry: "AGRICULTURE" },
    { edIndustry: "AGRO PRODUCTS" },
    { edIndustry: "AIR TRANSPORT" },
    {
        edIndustry: "AIRCRAFTSSPACECRAFTS BUILDREPAIR",
    },
    {
        edIndustry: "APPAREL/DRESSING/DYEING-MFG",
    },
    {
        edIndustry: "ARCHITECTURAL ENGG TECH ACTIVITY",
    },
    {
        edIndustry: "ARTISANS/CRAFTSMEN/HANDICRAFTS",
    },
    {
        edIndustry: "ARTIST DANCE OR MUSIC TEACHER",
    },
    { edIndustry: "ASTROLOGER" },
    { edIndustry: "AUTO TRANSPORT" },
    { edIndustry: "AUTOMOBILES" },
    { edIndustry: "BARBER" },
    { edIndustry: "BASIC METALS MFG" },
    {
        edIndustry: "TAXIS AUTO RICKSHAWS & SCOOTERS",
    },
    { edIndustry: "BIDI MAKING" },
    {
        edIndustry: "BPOS/CALL CENTRE/OTHER SERVICE",
    },
    {
        edIndustry: "BREWERIES AND DISTELLERIES",
    },
    { edIndustry: "BRICK MANUFACTURING" },
    { edIndustry: "CARGO VESSEL SERVICES" },
    { edIndustry: "CARPENTER" },
    { edIndustry: "CARPET CLOTH WEAVING MFG" },
    { edIndustry: "CASTINGS AND FORGINGS" },
    { edIndustry: "CEMENT-MFG" },
    {
        edIndustry: "CERAMIC TILES AND SANITARY WARES",
    },
    { edIndustry: "CHEMICAL TRADING" },
    {
        edIndustry: "CHEMICAL/CHEMICAL PRODUCT MFG",
    },
    { edIndustry: "CHEMIST DRUGS" },
    {
        edIndustry: "CIVIL ELECTRICAL SMALL CONTRACTOR",
    },
    { edIndustry: "COACHING CLASSES" },
    {
        edIndustry: "COFFEE PROCESSING AND BLENDING",
    },
    { edIndustry: "COMMERCIAL BANKS" },
    {
        edIndustry: "COMPUTER/RELATED ACTIVITIES",
    },
    { edIndustry: "CONSTRUCTION" },
    { edIndustry: "CO-OPERATIVE BANKS" },
    { edIndustry: "COPPER PRODUCTS" },
    {
        edIndustry: "COTTON TEXTILE/SPINNINGWEAVINGDYE",
    },
    { edIndustry: "COURIER" },
    { edIndustry: "DAILY GOVT SCHEME WAGERS" },
    { edIndustry: "DAIRY PRODUCTS MFG" },
    { edIndustry: "DAIRYING" },
    { edIndustry: "DIAGONISTIC CENTRE" },
    { edIndustry: "DIAMONDS GEMS JEWELLERY" },
    {
        edIndustry: "EDIBLE NUTS PROCESSING UNITS",
    },
    { edIndustry: "EDUCATION SERVICE" },
    { edIndustry: "ELECTRICAL MACHINERY MFG" },
    {
        edIndustry: "ELECTRICITY/GAS/HOT WATER SUPPLY",
    },
    {
        edIndustry: "ELECTRONIC/RADIO/TV/EQUIP -MFG",
    },
    { edIndustry: "EVENT MANAGEMENT" },
    {
        edIndustry: "EXTRACTION-PETROLEUM/NATURAL GAS",
    },
    { edIndustry: "FABRICATED METAL PRODUCTS" },
    {
        edIndustry: "Fashion Accessories AND Apparels",
    },
    { edIndustry: "FERTILIZERS" },
    {
        edIndustry: "Film Exhibitor Distributor",
    },
    { edIndustry: "FINANCIAL INTERMEDIATION" },
    { edIndustry: "FISHING" },
    { edIndustry: "FLOUR MILL" },
    { edIndustry: "Flourist Gift Gallery" },
    { edIndustry: "FMCG" },
    {
        edIndustry: "FOOD PRODUCTS/BEVERAGES-MFG",
    },
    { edIndustry: "FOODGRAINS" },
    { edIndustry: "FOOTWEAR" },
    { edIndustry: "FORESTRY/LOGGING SERVICES" },
    {
        edIndustry: "Freight  Container Movement",
    },
    { edIndustry: "FURNITURE; N.E.C. MFG" },
    { edIndustry: "GLASS/RELATED PRODUCT MFG" },
    { edIndustry: "GROCERY TRADING" },
    { edIndustry: "GYMNASIUM HEALTH CLUB SPA" },
    { edIndustry: "HAND TOOLS TRADER MANUF" },
    { edIndustry: "HANDICRAFTS" },
    {
        edIndustry: "HANDLOOM TEXTILE & KHADI/SPINWEAVE",
    },
    { edIndustry: "HEALTH AND SOCIAL WORK" },
    {
        edIndustry: "HEAVY ENGINEERING/EQUIPMENTS/MILLS",
    },
    { edIndustry: "HOSPITALS" },
    {
        edIndustry: "HOUSEHOLD HELPERS HOUSEMAIDS",
    },
    {
        edIndustry: "HOUSING FINANCE COMPANIES/CORP",
    },
    { edIndustry: "INDUSTRIAL GASES" },
    { edIndustry: "INFORMATION TECHNOLOGY" },
    {
        edIndustry: "INSURANCE AND PENSION FUNDING",
    },
    { edIndustry: "INTERIOR DECORATOR" },
    {
        edIndustry: "IRON AND STEEL/SMELTINGROLLING",
    },
    { edIndustry: "IT OUTSOURCING" },
    {
        edIndustry: "JEWELLERY & RELATED ACTIVITIES",
    },
    { edIndustry: "JUTE & MESTA" },
    { edIndustry: "KANDIL KITE MFG" },
    { edIndustry: "KHADI & VILLAGE INDUSTRY" },
    { edIndustry: "LAND /PIPELINES TRANSPORT" },
    {
        edIndustry: "LAND TRANSPORT-PVT.TRANSPORT COS",
    },
    {
        edIndustry: "LAUNDRIES/BEAUTY PARLOR/STUDIO",
    },
    { edIndustry: "LEASING COMPANIES" },
    {
        edIndustry: "LEASING RENTING AND BUSINESS ACT",
    },
    { edIndustry: "LEATHER TRADERS" },
    { edIndustry: "LEATHER/TANNING- MFG" },
    { edIndustry: "LEGAL ACTIVITIES" },
    {
        edIndustry: "LIGHT ENGINEERING/EQUIPMENTS/FRIDGE",
    },
    { edIndustry: "LOGISTICS AND TRANSPORT" },
    { edIndustry: "LPG CNG distributors" },
    { edIndustry: "LUBRICANTS" },
    {
        edIndustry: "MACHINERY/EQUIPMENTS N.E.C.MFG",
    },
    {
        edIndustry: "MANAGEMENT CONSULTANCY ACTIVITIES",
    },
    { edIndustry: "Manpower Consultant" },
    {
        edIndustry: "MANUFACTURE OF MOTOR VEHICLES",
    },
    { edIndustry: "MANUFACTURING" },
    { edIndustry: "MARBLE AND GRANITE" },
    { edIndustry: "MARINE PRODUCTS" },
    {
        edIndustry: "MARKET RESEARCH ACTIVITIES",
    },
    {
        edIndustry: "MATCHES EXPLOSIVES AMMUNITIONS",
    },
    { edIndustry: "MEDIA" },
    {
        edIndustry: "MEDICAL/HEALTH/SOCIAL WORK",
    },
    {
        edIndustry: "MEDICAL/OPTICAL/WATCHES MFG",
    },
    {
        edIndustry: "MERCHANT BANKING/ FINANCIAL SERVICE",
    },
    {
        edIndustry: "MERGER ACQUISITION ACTIVITIES",
    },
    { edIndustry: "MESS TIFFIN" },
    { edIndustry: "MFG OF SANITARY WARES" },
    { edIndustry: "MFG OF TILES" },
    {
        edIndustry: "MINING OF COAL AND LIGNITE",
    },
    { edIndustry: "MINING OF METAL ORES" },
    {
        edIndustry: "MINING OF URANIUM AND THORIUM",
    },
    { edIndustry: "Mobile Phones Allied" },
    { edIndustry: "MOTOR VEHICLES AND PARTS" },
    {
        edIndustry: "NBFC GENERAL PURPOSES LOANS",
    },
    { edIndustry: "NON - EDIBLE OILS MFG" },
    { edIndustry: "NON- FERROUS METALSBASIC" },
    {
        edIndustry: "NONMETALLIC MINERAL PRODUCTMFG",
    },
    {
        edIndustry: "OFFICE COMPUTING MACHINERY -MFG",
    },
    {
        edIndustry: "OIL DRILLING AND ALLIED SERVICES",
    },
    { edIndustry: "OILSEEDS" },
    { edIndustry: "OPTICIANS" },
    { edIndustry: "OTHERS" },
    { edIndustry: "PACKAGING" },
    {
        edIndustry: "PAINTS VARNISHESLACQUERSPOLISHES",
    },
    {
        edIndustry: "PAPER AND PAPER PRODUCTS-MFG",
    },
    {
        edIndustry: "PERFUMESCOSMETICSTOILETERIES",
    },
    {
        edIndustry: "PESTICIDES AGRO CHEMICAL PROD -MFG",
    },
    { edIndustry: "Petrol Pumps" },
    { edIndustry: "PHARMACEUTICALS-MFG" },
    {
        edIndustry: "PHOTOCHEMICALSSENSITISED FILMS",
    },
    { edIndustry: "PLASTIC PRODUCTS MFG" },
    {
        edIndustry: "POST AND TELECOMMUNICATIONS",
    },
    { edIndustry: "POTTERY" },
    { edIndustry: "POULTRY FARMING" },
    { edIndustry: "PRINTING" },
    {
        edIndustry: "PROCESSING OF NUCLEAR FUEL",
    },
    { edIndustry: "PROFESSIONAL SERVICES" },
    { edIndustry: "PROPERTY DEALER / BROKER" },
    { edIndustry: "PROPERTY DEVELOPER" },
    {
        edIndustry: "PUBLIC ADMINISTRATION/DEFENCE",
    },
    {
        edIndustry: "PUBLIC UTILITIES & SERVICES",
    },
    { edIndustry: "PUBLISHING/PRINTING" },
    {
        edIndustry: "PURIFICATION/DISTRIBUTION-WATER",
    },
    { edIndustry: "RATION SHOPS" },
    { edIndustry: "REAL ESTATE ACTIVITIES" },
    { edIndustry: "REAL ESTATE INVESTOR" },
    { edIndustry: "RECREATION SERVICES" },
    { edIndustry: "RECYCLING" },
    {
        edIndustry: "REFINED PETROLEUM PRODUCTS -MFG",
    },
    {
        edIndustry: "RENT/LEASE-MACHINERY/EQUIPMENT",
    },
    { edIndustry: "RESEARCH AND DEVELOPMENT" },
    { edIndustry: "RETAIL TRADERS" },
    { edIndustry: "RUBBER PRODUCTS MFG" },
    { edIndustry: "RUBBER TRADING" },
    { edIndustry: "SCRAP DEALER" },
    { edIndustry: "SCREEN PRINTING" },
    { edIndustry: "SERVICES" },
    {
        edIndustry: "SEWAGE/SANITATION ACTIVITIES",
    },
    { edIndustry: "SHIPPING LOGISTICS" },
    {
        edIndustry: "SILK & SYNTHETIC FIBRES & TEXTILES",
    },
    {
        edIndustry: "SOAPS WAXES AGARBATTI -MFG",
    },
    { edIndustry: "SOFT TOYS MFG" },
    { edIndustry: "SOFTWARE DEV. SERVICES" },
    { edIndustry: "SPARE PARTS TRADERS" },
    { edIndustry: "SPICES PICKLE PAPAD MFG" },
    { edIndustry: "SPORTS & ATHLETIC GOODS" },
    { edIndustry: "STATIONERY" },
    { edIndustry: "STEEL TRADING MANUF" },
    { edIndustry: "STOCK BROKING" },
    { edIndustry: "STORAGE AND WAREHOUSING" },
    {
        edIndustry: "SUGAR/SUGAR RELATED PRODUCT-MFG",
    },
    {
        edIndustry: "SUPPORT SERVICE TO LAND TRANSPORT",
    },
    {
        edIndustry: "SUPPORTING/AUXILIARY TRANSPORT",
    },
    {
        edIndustry: "TAXIS AUTO RICKSHAWS & SCOOTERS",
    },
    {
        edIndustry: "TEA PROCESSING AND BLENDING",
    },
    { edIndustry: "Telecom data services" },
    { edIndustry: "TEXTILES-MFG" },
    {
        edIndustry: "TOBACCO RELATED PRODUCTS-MFG",
    },
    {
        edIndustry: "TOURISM/HOTELS/RESTAURANTS",
    },
    { edIndustry: "TOURS AND TRAVELS" },
    {
        edIndustry: "TRADING OF CERAMIC RAW MATERIAL",
    },
    { edIndustry: "TRADING OF SANITARY WARES" },
    { edIndustry: "TRADING OF TILES" },
    {
        edIndustry: "TRADING OF TIMBER/WOODEN MATERIALS",
    },
    {
        edIndustry: "TRANSPORT STORAGE & COMMUNICATIONS",
    },
    {
        edIndustry: "VEHICLE PARTS AND ACCESSORIES -MFG",
    },
    { edIndustry: "VISA CONSULTANT" },
    { edIndustry: "WADAPAV FAST FOOD MFG" },
    { edIndustry: "WATER SUPPLY" },
    { edIndustry: "WATER TRANSPORT" },
    {
        edIndustry: "WOLLEN TEXTILE INC CLEANINGBAILING",
    },
    {
        edIndustry: "WOOD/ WOOD PRODUCTS/FURNITURE",
    },
    {
        edIndustry: "WOOD/CORK EXCEPT FURNITURE-MFG",
    },
];
